import styled from 'styled-components';

/* Must stay below HeaderContainer's z-index so the sticky header wins on overlap. */
const SIDEBAR_Z_INDEX = 90;

export const SidebarContainer = styled.div<{
  $isOpen: boolean;
  $position: 'left' | 'right';
}>`
  position: absolute;
  top: 0;
  ${({ $position }) => $position}: 0;
  z-index: ${SIDEBAR_Z_INDEX};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: ${({ theme }) =>
    theme.colors.backgroundDark ?? theme.colors.backgroundPrimary};
  color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
  padding: 1rem;
  width: ${({ $isOpen }) => ($isOpen ? '200px' : '52px')};
  height: ${({ $isOpen }) => ($isOpen ? '100%' : '52px')};
  overflow-y: ${({ $isOpen }) => ($isOpen ? 'auto' : 'hidden')};
  transition:
    width 0.3s ease-in-out,
    height 0.3s ease-in-out;
`;

export const SidebarContent = styled.div<{ $isOpen: boolean }>`
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  transition: opacity 0.4s ease-in-out;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  width: 100%;
  overflow-x: hidden;
  color: inherit;
`;

export const ToggleButton = styled.button`
  position: sticky;
  top: 0;
  align-self: flex-end;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  background-color: inherit;
  color: inherit;
  border: none;
  cursor: pointer;
  z-index: 2;
`;

export const SidebarItem = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 8px 0;
  color: ${({ theme, $isActive }) =>
    $isActive
      ? theme.colors.primary
      : (theme.colors.text.onDark ?? theme.colors.background)};
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
